module.exports = __webpack_public_path__ + "static/media/ace_00006.b262aada.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/ace_00006.png
// module id = 250
// module chunks = 0